import { render, staticRenderFns } from "./MoreModal.vue?vue&type=template&id=8e257a32&scoped=true"
import script from "./MoreModal.vue?vue&type=script&lang=js"
export * from "./MoreModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e257a32",
  null
  
)

export default component.exports